import { makeQuery } from 'shared/utilities';

export const ispringDisconnectQuery = async function () {
    return await makeQuery<{}>('/ispring/disconnect', {
        method: 'post'
    });
}
